import '../scss/index.scss';
import './webcomponents/wc-header';
import './webcomponents/wc-footer';
import './webcomponents/exposed-nav/kmx-thumb-nav';
import { appElId } from './webcomponents/exposed-nav/constants';
import { componentsStore, IComponentsLoaded, } from "./componentsStore";
import * as app from './app/app'
import { IMenuData, navStore } from './webcomponents/exposed-nav/store';

const { validateUserCookie } = navStore.getState() as IMenuData;
validateUserCookie();

const initApp = ({ headerLoaded, footerLoaded, appInitialized, setAppInitialized }: IComponentsLoaded, force?: boolean) =>
{
    if(!appInitialized && force) {
        app.start();
        setAppInitialized();
        return;
    }

    if(appInitialized || !headerLoaded || !footerLoaded) return;

    app.start();
    setAppInitialized();
}

// optimistically try to load
initApp(componentsStore.getState() as IComponentsLoaded);

// After half a second, force app init even if both components haven't loaded
window.setTimeout(() => {
    initApp(componentsStore.getState() as IComponentsLoaded, true);
}, 300);

const kmx_thumb_nav = document.createElement('kmx-thumb-nav');
kmx_thumb_nav.id = appElId;
document.body.prepend(kmx_thumb_nav);
